<template>
    <div class="gallery" :class="[bemFacet]">
        <div class="gallery--break-out" :style="breakOutStyles">
            <div class="gallery--wrap">
                <div class="gallery--rail grid grid__gallery">
                    <div class="gallery--container">
                        <ul class="u-reset gallery--items" :class="[isFluid ? '' : 'grid--row']">
                            <li class="gallery--item" :class="[isFluid ? '' : 'grid--col']"
                                    v-for="(plugin, pluginIdx) in plugins" :key="pluginIdx">
                                <component :is="plugin.type" :plugin="plugin"
                                        :position-id="positionId(pluginIdx)">
                                </component>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!-- <pre v-if="content" v-text="content"></pre> -->
        <!-- <pre v-if="plugins" v-text="plugins"></pre> -->
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { toNumeral, numerals } from 'util/dom/mq';
    import uuidMixin from 'framework/mixins/uuid';
    import bemMixin from 'framework/mixins/bem';
    import cmsPluginMixin from 'framework/mixins/cms/cms-plugin';


    export default {
        mixins: [
            uuidMixin,
            bemMixin('gallery', { useProp: false }),
            cmsPluginMixin,
        ],
        computed: {
            ...mapGetters(['viewport', 'scroll']),
            facet() {
                return this.content.facet || 'base';
            },
            isFluid() {
                return this.viewport.type === 'print' ? false : toNumeral(this.viewport.mq.query) <= numerals.SM;
            },
            breakOutStyles() {
                const scrollbarWidth = this.scroll.scrollbarWidth;

                return this.isFluid ? {
                    'padding-right': `${ scrollbarWidth }px`,
                    transform: `translateX(-50%) translateX(${ scrollbarWidth * 0.5 }px)`,
                } : {};
            },
        },
        methods: {
            positionId(pluginIdx) {
                return [this.uuid, pluginIdx.toString()];
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/cms-plugins/gallery/index.vue?0e48bd70